(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/category-menu/assets/javascripts/category-menu.js') >= 0) return;  svs.modules.push('/widgets/category-menu/assets/javascripts/category-menu.js');
"use strict";


const categoryMenus = document.getElementsByClassName('js-category-menu-widget');
if (categoryMenus.length > 0) {
  const options = {
    useScrollFaders: true,
    el: 'js-category-menu',
    class: 'js-category-menu'
  };
  new svs.ui.ItemsMenu(options);
}
for (let index = 0; index < categoryMenus.length; index++) {
  const currMenu = categoryMenus[index];
  const currWidgetTopInViewport = currMenu.parentNode.getBoundingClientRect().top;
  const allWidgetsAreaTopInViewport = currMenu.parentNode.parentNode.getBoundingClientRect().top;
  const isFirstVisibleWidget = currWidgetTopInViewport === allWidgetsAreaTopInViewport;
  currMenu.dataset.transform = isFirstVisibleWidget ? 'never' : 'desktop';
}

 })(window);